import React from 'react';

const Break = ({margin}) => {
    return (
        <div style={{margin: margin ? margin : "20px"}}/>
    );
};

export default Break;